import toast from 'react-hot-toast';
import Container from 'react-bootstrap/Container';
import Flatpickr from "react-flatpickr";

import { useEffect, useState } from 'react';
import { Modal, Button } from "react-bootstrap";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import { formataDate, formataDatetime } from '../../util/datas'
import { toastErrorPydantic } from '../../util/toast_pydantic';

import FlatpickrControlled from '../FlatpickrControlled'

import {
  servGetPendenciaFormularioComHistorico,
  servAtualizaPendenciaFormulario
} from '../../servicos/servicosEmRotasPrivadas/pendencia_relatorio_acompanhamento';
import {
  servGetAllStatusTransitorios
} from '../../servicos/servicosEmRotasPrivadas/status';

import smartToast from '../../util/smart_toast';

function RespPendItemModal({ show, handleClose, pendenciaId, fetchItensAoFechar, statusOpcoes }) {

  console.log('#### Iniciando RespPendItemModal ####');

  const limiteCaracteresObs = 3000;

  const [pendencia, setPendencia] = useState(null)
  const [countCaracteresObs, setCountCaracteresObs] = useState(0)
  const [exibeResumo, setExibeResumo] = useState(false)

  console.log(pendencia);

  useEffect(() => {
    if (pendenciaId) getPendenciaFormularioComHistorico()
    setCountCaracteresObs(0)
  }, [pendenciaId]);

  const getPendenciaFormularioComHistorico = async () => {
    try {
      const { data } = await toast.promise(
        servGetPendenciaFormularioComHistorico(pendenciaId),
        {
          loading: 'Buscando pendência e informações de histórico...'
        }
      )
      setPendencia(data);
    } catch (error) {
      toastErrorPydantic(error)
    }
  }

  const handlerEditaPendencia = (campo, valor) => {
    setPendencia(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const handlerContaCaracteres = (e) => {
    setCountCaracteresObs(e.length)
  };

  const atualizaPendenciaFormulario = async (e) => {

    e.preventDefault();

    try {

      await toast.promise(
        servAtualizaPendenciaFormulario(pendencia),
        {
          loading: 'Enviando atualização...',
          success: (response) => response.message
        }
      )

      fetchItensAoFechar()
      handleClose();

    } catch (error) {
      toastErrorPydantic(error)
    }

  }

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
      {statusOpcoes &&
        <form onSubmit={atualizaPendenciaFormulario}>
          <Modal.Header closeButton>
            <Modal.Title>Responder Pendência</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>

              {pendencia &&

                <div className='d-flex flex-column gap-3'>
                  <p className='m-0'>Pendência resolvida?</p>
                  <div className='d-flex gap-2'>
                    {statusOpcoes && statusOpcoes.map((status) => (

                      <div key={status.id} className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id={status.id}
                          value={status.id}
                          checked={pendencia.statusId === status.id}
                          onChange={() => setPendencia(prev => ({
                            ...prev,
                            statusId: status.id,
                            statusResolvido: status.resolvido
                          }))}
                        />
                        <label className="form-check-label" htmlFor={status.id}>{status.resolvido}</label>
                      </div>

                    ))}
                  </div>

                  <div className='d-flex flex-column gap-2'>
                    {pendencia.statusResolvido === 'Sim' ? (
                      <div className='form-group'>
                        <label htmlFor='dataResolucao'>Data de resolução</label>
                        <div className='col-12 col-md-3'>
                          <FlatpickrControlled
                            name='dataResolucao'
                            date={pendencia.dataResolucao}
                            onChange={(value) => handlerEditaPendencia('dataResolucao', value)}
                            // onChange={([value]) => setPendencia(prev => ({
                            //   ...prev,
                            //   dataResolucao: value
                            // }))}
                          />
                        </div>
                      </div>
                    ) : pendencia.statusResolvido === 'Em andamento' ? (
                      <div className='form-group'>
                        <label htmlFor='dataPrevisaoResolucao'>Data de previsão para resolução</label>
                        <div className='col-12 col-md-3'>
                          <FlatpickrControlled
                            date={pendencia.dataPrevisaoResolucao}
                            onChange={(value) => handlerEditaPendencia('dataPrevisaoResolucao', value)}
                          />
                        </div>
                      </div>
                    ) : (
                      <>
                        {/* Não retorna campo de data */}
                      </>
                    )}

                    <div className="input-group">
                      <span className="input-group-text">Observação</span>
                      <textarea
                        className="form-control form-control-sm"
                        // aria-label="With textarea"
                        placeholder={pendencia.observacao && `*** Última Observação da pendência = ${pendencia.observacao}`}
                        onBlur={(e) => handlerEditaPendencia("observacao", e.target.value)}
                        onChange={(e) => handlerContaCaracteres(e.target.value)}
                        required
                      />
                    </div>
                    <div className='d-flex gap-1'>
                      {countCaracteresObs > limiteCaracteresObs ? <p className='m-0 text-danger'>Caracteres: {countCaracteresObs}</p> : <p className='m-0'>Caracteres: {countCaracteresObs}</p>}
                      <p className='m-0'>-- Limite: {limiteCaracteresObs}</p>
                    </div>

                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="exibeResumo"
                        name="exibeResumo"
                        checked={exibeResumo}
                        onChange={(e) => setExibeResumo(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="exibeResumo">
                        Exibir Resumo Fragilidades
                      </label>
                    </div>

                    {exibeResumo &&
                      (
                        pendencia.resumoFragilidadesDetectadas
                          ?
                          <div className=''>
                            <p className='m-0'><strong>Resumo das Fragilidades do Relatório que gerou essa pendência:</strong> {pendencia.resumoFragilidadesDetectadas}</p>
                          </div>
                          :
                          <div>
                            <p className='m-0'>Não há Resumo das Fragilidades no documento que gerou essa pendência</p>
                          </div>
                      )
                    }

                    <table className="table">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Data Previsão Resolução</th>
                          <th>Data Alteração</th>
                          <th>Editor</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendencia.historico && pendencia.historico.map((historico) => (
                          <tr key={historico.histId}>
                            <th scope="row">{historico.status}</th>
                            <td>{formataDate(historico.dataPrevisaoResolucao, 'dd/MM/yyyy')}</td>
                            <td>{formataDatetime(historico.dataAlteracao)}</td>
                            <td>{historico.audNome}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              }

            </Container>
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-center">
              <Button type='submit' variant="primary">SALVAR</Button>
              <Button variant="secondary" onClick={handleClose}>CANCELAR</Button>
            </div>
          </Modal.Footer>
        </form>
      }
    </Modal >
  );
}

export default RespPendItemModal;
